import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=4d6f21ac&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4d6f21ac', component.options)
    } else {
      api.reload('4d6f21ac', component.options)
    }
    module.hot.accept("./VerDetalleModal.vue?vue&type=template&id=4d6f21ac&", function () {
      api.rerender('4d6f21ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerieActiva/VerDetalleModal.vue"
export default component.exports